/**
 * Measuring a `video` element (docs/ops-protocol.md, "Video and audio"). A
 * player view fills what it is offered, like a resizable image: a finite
 * proposal is taken as is; an axis left open follows the video's aspect
 * ratio (its `width` / `height` props once the page has read the metadata,
 * 16:9 before); with both open it is the video's own size, or 320 × 180.
 */

import type { Proposal, Size } from './types';

export const VIDEO_DEFAULT_SIZE: Size = { width: 320, height: 180 };

export function videoSize(props: Record<string, unknown>, p: Proposal): Size {
  const width = typeof props['width'] === 'number' && props['width'] > 0 ? props['width'] : null;
  const height = typeof props['height'] === 'number' && props['height'] > 0 ? props['height'] : null;
  const aspect = width !== null && height !== null ? width / height : VIDEO_DEFAULT_SIZE.width / VIDEO_DEFAULT_SIZE.height;
  const pw = p.width !== null && Number.isFinite(p.width) ? p.width : null;
  const ph = p.height !== null && Number.isFinite(p.height) ? p.height : null;
  if (pw !== null && ph !== null) return { width: pw, height: ph };
  if (pw !== null) return { width: pw, height: pw / aspect };
  if (ph !== null) return { width: ph * aspect, height: ph };
  if (width !== null && height !== null) return { width, height };
  return { ...VIDEO_DEFAULT_SIZE };
}
